import type React from 'react';
import { useMemo, useSyncExternalStore } from 'react';
import { buildVScaleVars, computeVScale } from '@/utils/vScale';

function getSnapshot() {
  return computeVScale(window.innerHeight);
}

function getServerSnapshot() {
  return 1;
}

function subscribe(cb: () => void) {
  window.addEventListener('resize', cb);
  return () => window.removeEventListener('resize', cb);
}

/** Returns a 0.65–1.0 vertical scale factor based on viewport height. */
export function useVScale(): number {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

/**
 * Returns a CSSProperties map of `--vs-{N}` variables scaled to the current viewport.
 * Spread onto a container's `style` prop — children reference via `var(--vs-47, 47px)`.
 */
export function useVScaleVars(): React.CSSProperties {
  const vs = useVScale();
  return useMemo(() => buildVScaleVars(vs) as unknown as React.CSSProperties, [vs]);
}
